
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux'
import createStore from './redux/store';
import GratisForm from './containers/GratisForm';

import {setOffice} from './redux/modules/office';
import {setOptions} from './redux/modules/options';
import {setProductCode} from './redux/modules/product';

import QueryString from 'qs';

const store = createStore();

let srch = location.search;
srch = srch.indexOf( '?' ) === 0 ? srch.substr( 1 ) : srch;
const qs = QueryString.parse( srch );
const _productCode = qs.productCode || qs.isbn || qs.product || qs.i || qs.p;
const _office = qs.office || qs.country || qs.o || qs.c;


// XXX: the react-gcaptcha library doesn't automatically include the recaptcha library
//      so we need to make sure it's loaded...and ASAP.
const callbackName = 'onloadcallback';
const lang = typeof window !== 'undefined' && (window.recaptchaOptions && window.recaptchaOptions.lang) ?
    '&hl=' + window.recaptchaOptions.lang :
    '';
const URL = `https://www.google.com/recaptcha/api.js?onload=${callbackName}&render=explicit${lang}`;

const gr = document.createElement( 'script' );
gr.src = URL;
gr.async = true;
document.getElementsByTagName( 'head' )[ 0 ].appendChild( gr );

class GratisApp {

    constructor( props ) {
        props = props || {};
        this.options = props || {};
        // TODO: externalize these default values (ENV)
        if(location.href.includes('uat')){
            this.options.ws = this.options.ws || { base: 'https://he-gratis-ws-dev.oupsupport.com'};
        }else{
            this.options.ws = this.options.ws || { base: 'https://he-gratis-ws.oupsupport.com'};
        }
        this.options.recaptcha = this.options.recaptcha || { siteKey: '6LfujAcTAAAAAFme14h5-LhfuLAZLcXVxMVAkFH-' };
        store.dispatch( setOptions( this.options ) );
        store.dispatch( setOffice( props.office || _office ) );
        store.dispatch( setProductCode( props.productCode || _productCode ) );
    }

    errorStyle( field ) {
        if ( this.props.response && this.props.response.errorFields && this.props.response.errorFields.indexOf( field ) >= 0 ) {
            return this.props.options.errorStyle || {
                    label: { color: '#c00' },
                    input: { backgroundColor: '#fee' }
                }
        }
        else {
            return {
                label: null,
                input: null
            }
        }
    }

    render( elName ) {
        ReactDOM.render(
            <Provider store={store}>
                <GratisForm errorStyle={this.errorStyle} params={qs} options={this.options}/>
            </Provider>,
            document.getElementById( elName )
        );
    }
}

module.exports = GratisApp;



// WEBPACK FOOTER //
// ./src/form/GratisApp.js